declare global {
  interface Window {
    _paq: MatomoTracker;
  }
}

type MatomoTracker = {
  push: (
    options:
      | [
          "trackEvent",
          TrackingCategory,
          string,
          string | undefined,
          number | undefined,
        ]
      | ["setCustomUrl", string]
      | ["trackPageView", string | undefined]
      | ["trackPageView"],
  ) => void;
};

enum TrackingCategory {
  Anmeldelseskjema = "Anmeldelseskjema",
  AnmeldelseskjemaEvent = "Anmeldelseskjema_hendelse",
  TekniskFeil = "Anmeldelseskjema_Teknisk_Feil",
}

type UserAction = "Legg til vedlegg"
  | "Select chip"
  | "Select dropdown"
  | "Klikk feilmelding"
  | "Klikk send inn"
  | "Klikk rediger utkast"
  | "Click EksternLink"
  | "Click radio"
  | "Click InternLink"
  | "Click checkbox"
  | "Click button"
  | "Click steg";

export enum EventAction {
  AnmeldelseSendtInn = "Anmeldelse sendt inn",
  AnmeldelseHarValideringsfeil = "Anmeldelse har valideringsfeil",
  BrukerInnloggetUtenTilgang = "Bruker innlogget uten tilgang",
}

export enum ErrorAction {
  RateLimitExceeded = "Rate limit exceeded",
  ErrorBoundary = "ErrorBoundary",
  InnsendingFeilet = "Innsending feilet",
}

interface Track{
  userAction: (action: UserAction, name?: string, value?: number) => void;
  eventAction: (action: EventAction, name?: string, value?: number) => void;
  error: (action: ErrorAction, name?: string, value?: number) => void;
  pageView: (customTitle?: string) => void;
}

export const track: Track = {
  /**
   * Tracker en handling som en bruker har gjort
   * @param action
   * @param name
   * @param value
   */
  userAction: function(action, name?, value?){
    trackEventToMatomo(TrackingCategory.Anmeldelseskjema, action, name, value);

  },
  /**
   * Tracker en hendelse som har skjedd i applikasjonen, som ikke nødvendigvis er en brukerhandling. Eksempel tid brukt i minutter på å fylle ut et skjema.
   * @param action
   * @param name
   * @param value
   */
  eventAction: function(action, name?, value?){
    trackEventToMatomo(TrackingCategory.AnmeldelseskjemaEvent, action, name, value);

  },
  error: function(action, name?, value?){
    trackEventToMatomo(TrackingCategory.TekniskFeil, action, name, value);
  },
  pageView: function(customTitle){
    trackPageViewToMatomo(customTitle);
  }
}


function trackPageViewToMatomo(customTitle?: string) {
  try {
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    const _paq = window["_paq"] || [];
    const url = window.location.pathname;
    const maskedUrl = url.replace(/\/[0-9a-fA-F-]{36}/, "/[UUID]"); // Mask UUID
    _paq.push(["setCustomUrl", maskedUrl]);
    if (customTitle) {
      _paq.push(["trackPageView", customTitle]);
    } else {
      _paq.push(["trackPageView"]);
    }
  } catch (e) {
    console.log("Feil med tracking", e);
  }
}

function trackEventToMatomo(
  category: TrackingCategory,
  action: UserAction | ErrorAction | EventAction,
  name?: string,
  value?: number,
) {
  try {
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    const _paq = window["_paq"] || [];
    _paq.push(["trackEvent", category, `Anmeldelse: ${action}`, name, value]); //Bruk av dette er dokumentert her: https://developer.matomo.org/api-reference/tracking-javascript
  } catch (e) {
    console.log("Feil med tracking", e);
  }
}
